/**
 * ATTENTION! This file is auto-generated for the 'llm' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { LlmAgentRepository } from '../server/repositories/LlmAgentRepository';
import type { LlmAgentRunRepository } from '../server/repositories/LlmAgentRunRepository';
import type { LlmAgentRunStepRepository } from '../server/repositories/LlmAgentRunStepRepository';
import type { LlmAssistantRepository } from '../server/repositories/LlmAssistantRepository';
import type { LlmAssistantSessionRepository } from '../server/repositories/LlmAssistantSessionRepository';
import type { LlmAssistantMemoryRepository } from '../server/repositories/LlmAssistantMemoryRepository';
import type { LlmAssistantMessageRepository } from '../server/repositories/LlmAssistantMessageRepository';
import type { LlmAssistantToolCallRepository } from '../server/repositories/LlmAssistantToolCallRepository';
import type { LlmToolRepository } from '../server/repositories/LlmToolRepository';
import type { LlmModelRepository } from '../server/repositories/LlmModelRepository';
import type { SessionContextRepository } from '../server/repositories/SessionContextRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type LlmAgentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmAgentRepository>;
export function useLlmAgentRepository(): LlmAgentRepositoryClient { return makeRepositoryProxy<LlmAgentRepositoryClient>('llm::LlmAgentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmAgentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmAgentRepository = useLlmAgentRepository();

type LlmAgentRunRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmAgentRunRepository>;
export function useLlmAgentRunRepository(): LlmAgentRunRepositoryClient { return makeRepositoryProxy<LlmAgentRunRepositoryClient>('llm::LlmAgentRunRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmAgentRunRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmAgentRunRepository = useLlmAgentRunRepository();

type LlmAgentRunStepRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmAgentRunStepRepository>;
export function useLlmAgentRunStepRepository(): LlmAgentRunStepRepositoryClient { return makeRepositoryProxy<LlmAgentRunStepRepositoryClient>('llm::LlmAgentRunStepRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmAgentRunStepRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmAgentRunStepRepository = useLlmAgentRunStepRepository();

type LlmAssistantRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmAssistantRepository>;
export function useLlmAssistantRepository(): LlmAssistantRepositoryClient { return makeRepositoryProxy<LlmAssistantRepositoryClient>('llm::LlmAssistantRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmAssistantRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmAssistantRepository = useLlmAssistantRepository();

type LlmAssistantSessionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmAssistantSessionRepository>;
export function useLlmAssistantSessionRepository(): LlmAssistantSessionRepositoryClient { return makeRepositoryProxy<LlmAssistantSessionRepositoryClient>('llm::LlmAssistantSessionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmAssistantSessionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmAssistantSessionRepository = useLlmAssistantSessionRepository();

type LlmAssistantMemoryRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmAssistantMemoryRepository>;
export function useLlmAssistantMemoryRepository(): LlmAssistantMemoryRepositoryClient { return makeRepositoryProxy<LlmAssistantMemoryRepositoryClient>('llm::LlmAssistantMemoryRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmAssistantMemoryRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmAssistantMemoryRepository = useLlmAssistantMemoryRepository();

type LlmAssistantMessageRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmAssistantMessageRepository>;
export function useLlmAssistantMessageRepository(): LlmAssistantMessageRepositoryClient { return makeRepositoryProxy<LlmAssistantMessageRepositoryClient>('llm::LlmAssistantMessageRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmAssistantMessageRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmAssistantMessageRepository = useLlmAssistantMessageRepository();

type LlmAssistantToolCallRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmAssistantToolCallRepository>;
export function useLlmAssistantToolCallRepository(): LlmAssistantToolCallRepositoryClient { return makeRepositoryProxy<LlmAssistantToolCallRepositoryClient>('llm::LlmAssistantToolCallRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmAssistantToolCallRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmAssistantToolCallRepository = useLlmAssistantToolCallRepository();

type LlmToolRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmToolRepository>;
export function useLlmToolRepository(): LlmToolRepositoryClient { return makeRepositoryProxy<LlmToolRepositoryClient>('llm::LlmToolRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmToolRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmToolRepository = useLlmToolRepository();

type LlmModelRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LlmModelRepository>;
export function useLlmModelRepository(): LlmModelRepositoryClient { return makeRepositoryProxy<LlmModelRepositoryClient>('llm::LlmModelRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLlmModelRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const llmModelRepository = useLlmModelRepository();

type SessionContextRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SessionContextRepository>;
export function useSessionContextRepository(): SessionContextRepositoryClient { return makeRepositoryProxy<SessionContextRepositoryClient>('llm::SessionContextRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSessionContextRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const sessionContextRepository = useSessionContextRepository();

type getMcpToolsType = typeof import('../server/functions/getMcpTools').getMcpTools;
export const getMcpTools: RpcFunctionClient<getMcpToolsType> = makeFunctionProxy<getMcpToolsType>('llm::getMcpTools');

type getAgentMetadataType = typeof import('../server/functions/getAgentMetadata').getAgentMetadata;
export const getAgentMetadata: RpcFunctionClient<getAgentMetadataType> = makeFunctionProxy<getAgentMetadataType>('llm::getAgentMetadata');

type getEventListType = typeof import('../server/functions/getEventList').getEventList;
export const getEventList: RpcFunctionClient<getEventListType> = makeFunctionProxy<getEventListType>('llm::getEventList');

type startBaseAssistantStreamType = typeof import('../server/functions/startBaseAssistantStream').startBaseAssistantStream;
export const startBaseAssistantStream: RpcFunctionClient<startBaseAssistantStreamType> = makeFunctionProxy<startBaseAssistantStreamType>('llm::startBaseAssistantStream');

type stopBaseAssistantStreamType = typeof import('../server/functions/stopBaseAssistantStream').stopBaseAssistantStream;
export const stopBaseAssistantStream: RpcFunctionClient<stopBaseAssistantStreamType> = makeFunctionProxy<stopBaseAssistantStreamType>('llm::stopBaseAssistantStream');

type searchMemoryByEmbeddingType = typeof import('../server/functions/searchMemoryByEmbedding').searchMemoryByEmbedding;
export const searchMemoryByEmbedding: RpcFunctionClient<searchMemoryByEmbeddingType> = makeFunctionProxy<searchMemoryByEmbeddingType>('llm::searchMemoryByEmbedding');

type appendSessionContextType = typeof import('../server/functions/appendSessionContext').appendSessionContext;
export const appendSessionContext: RpcFunctionClient<appendSessionContextType> = makeFunctionProxy<appendSessionContextType>('llm::appendSessionContext');

type appendEntityContextType = typeof import('../server/functions/appendEntityContext').appendEntityContext;
export const appendEntityContext: RpcFunctionClient<appendEntityContextType> = makeFunctionProxy<appendEntityContextType>('llm::appendEntityContext');

type getAssistantMessageHistoryType = typeof import('../server/functions/getAssistantMessageHistory').getAssistantMessageHistory;
export const getAssistantMessageHistory: RpcFunctionClient<getAssistantMessageHistoryType> = makeFunctionProxy<getAssistantMessageHistoryType>('llm::getAssistantMessageHistory');

type getBaseSessionIdType = typeof import('../server/functions/getBaseSessionId').getBaseSessionId;
export const getBaseSessionId: RpcFunctionClient<getBaseSessionIdType> = makeFunctionProxy<getBaseSessionIdType>('llm::getBaseSessionId');
